module.exports = __webpack_public_path__ + "static/media/logo.77593beb.png";